/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export enum PreSetupTemplateSteps {
    None = 'None',
    BrowseTemplates = 'BrowseTemplates',
    PreviewTemplate = 'PreviewTemplate',
    SelectScope = 'SelectScope',
    SelectTeam = 'SelectTeam',
    CreateAdminGroup = 'CreateAdminGroup',
}

export interface PreSetupTemplateStepProps {
    navigateTo: (step: PreSetupTemplateSteps) => void;
    done: () => void;
}
